// extracted by mini-css-extract-plugin
module.exports = {"desktopVideo":"jam-video-module--desktopVideo--1ZL70","mobileVideo":"jam-video-module--mobileVideo--3dzj2"};